import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCKingAxalotyl extends NPC {
    constructor() {
        super(definitions.NPC_ID.KING_AXALOTYL);

        this.collisionRadius = 50;
        this.collisionOffsetX = 24;
        this.collisionOffsetY = -54;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_king_axalotyl_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 1, new PIXI.Point(24, -20));
        this.animateIdle(2);
    }

    onViewAdded() {
        super.onViewAdded();

        this._status.x += 27;
        this._status.y += 8;
    }
}